var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle',{attrs:{"cx":"294.5","cy":"485.5","r":"3.5","transform":"translate(-291 -482)","fill":"currentColor","fill-rule":"evenodd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }